import React from 'react';

const Title = ({ text, cl }) => {
  return <h2 className={cl('block-title')} dangerouslySetInnerHTML={{ __html: text }} />;
};

export default Title;
